export class VehicleEmissionTestModel {
    public id: number;
    public vehicleId: number;
    public emissionCertificateTypeID: number;
    public emissionAreaTypeID: number;
    public emissionTestTypeID: number;
    public emissionTestResultTypeID: number;
    public initialTest: boolean;
    public initialTestDate: Date;
    public testPassedDate: Date;
    public testExpirationDate: Date;
    public modified: boolean;
    public isDomicileAddressExempted: boolean;
}
